import { useScrollToTop } from '../../hooks/useScrollToTop'

/**
 * Component that handles scrolling to top on route changes
 * Should be placed inside Router but outside of Routes
 */
export const ScrollToTop = () => {
  useScrollToTop()
  return null
}
